import { createResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';
export const portalSettingsContextResource = createResource<ServiceDeskContext>({
	type: RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-portal-settings-context", jiraSpaEntry: "async-resource-portal-settings-context" */ './get-data'
		),
});

export type ServiceDeskContext = {
	announcementSettings: {
		canAgentsManageHelpCenterAnnouncement: boolean;
		canAgentsManagePortalAnnouncement: boolean;
	};
	serviceDeskOpenAccess: boolean;
	canAdministerJIRA: boolean;
	description: string;
	descriptionWiki: string;
	name: string;
	portalId: number;
	portalLogoUrl: string;
	projectId: number;
	projectKey: string;
	portalUrl: string;
	helpCenterUrl: string;
};
